import Modal from 'react-modal';
import "../../styles/AdminPage.css";
import Button, { BUTTON_TYPES } from '../Button';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { FaTimes } from "react-icons/fa";
import LabeledCheckbox from '../inputs/LabeledCheckBox';
import toast from 'react-hot-toast';
import { archiveEvent } from '../../api/admin/AdminDashboardAPI';

Modal.setAppElement('#root');

const EventArchiveModal = ({ isOpen, onClose, event, removeEvent, updateEventWithRecurrence }) => {

    const [isDeleteRecurringEnabled, setIsDeleteRecurringEnabled] = useState(false);

    const handleDeleteRecurringChange = (eventRecurr) => {
        setIsDeleteRecurringEnabled(eventRecurr.target.checked);
    };

    const handleArchive = (eventArch) => {
        toast.loading("Archiving Event...");
        setTimeout(async () => {
            try {
                const response = await archiveEvent(eventArch, isDeleteRecurringEnabled);
                if (response.status === 200) {
                    toast.dismiss();
                    if (isDeleteRecurringEnabled) {
                        toast.success("Events archived!");
                        updateEventWithRecurrence();
                    } else {
                        toast.success("Event archived!");
                        removeEvent(eventArch);
                    }
                    
                    onClose();
                } else {
                    toast.dismiss();
                    toast.error("Event failed to archive. Status: " + response.status);
                }
            } catch (error) {
                toast.dismiss();
                console.error("Error archiving event:", error);
                toast.error("Something went wrong. Please check your connection and try again.");
            }
        }, 300);
    }


    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="Event Archive Modal"
            className="custom-modal-content delete-modal"
            overlayClassName="custom-modal-overlay"
        >
            <>
                <div className='d-flex flex-row justify-content-between align-items-center mb-3'>
                    <h2 className="text-start fs-4 mb-0">Are you sure you want to archive this event?</h2>
                    <div className='d-flex flex-row justify-content-end align-items-center me-1'>
                        <button className="close-btn" onClick={onClose}>{<FaTimes />}</button>
                    </div>
                </div>
                {(event.recurrence) && (
                    <div className="d-flex flex-row justify-content-between mb-2">
                        <LabeledCheckbox
                            id="delete-recurring-checkbox"
                            label="Archive/Delete All Future Recurrences:"
                            checked={isDeleteRecurringEnabled}
                            onChange={handleDeleteRecurringChange}
                            disabled={false}
                        />
                    </div>
                )}
                <div className='d-flex flex-row justify-content-center align-items-center two-button-container'>
                    <div className='me-3'>
                        <Button
                            id="filter-button-modal"
                            type={BUTTON_TYPES.outline}
                            buttonText="Cancel"
                            action={() => { onClose() }}
                        />
                    </div>
                    <Button
                        id="delete-event-confirm-button"
                        type={BUTTON_TYPES.danger}
                        buttonText="Confirm"
                        action={() => { handleArchive(event) }}
                    />
                </div>
            </>
        </Modal>
    );
};

EventArchiveModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    event: PropTypes.object.isRequired,
    removeEvent: PropTypes.func.isRequired,
    updateEventWithRecurrence: PropTypes.func.isRequired,
};

export default EventArchiveModal;
